module.exports = __webpack_public_path__ + "img/logo-um-fkkt.040f6701.png";